export const convertToDate = (date: string): Date => {
  return new Date(Date.parse(date))
}

export const dateString = (date: string): string => {
  return convertToDate(date).toLocaleString("de-CH", {dateStyle: "long"})
}
